import { render, staticRenderFns } from "./CustomerChip.vue?vue&type=template&id=eed7a010&scoped=true"
import script from "./CustomerChip.vue?vue&type=script&lang=js"
export * from "./CustomerChip.vue?vue&type=script&lang=js"
import style0 from "./CustomerChip.vue?vue&type=style&index=0&id=eed7a010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed7a010",
  null
  
)

export default component.exports